import { render } from "./MemberItem.vue?vue&type=template&id=a0aeaac8&scoped=true"
import script from "./MemberItem.vue?vue&type=script&lang=js"
export * from "./MemberItem.vue?vue&type=script&lang=js"

import "./MemberItem.vue?vue&type=style&index=0&id=a0aeaac8&lang=scss&scoped=true"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0aeaac8"]])

export default __exports__